export const getWaitingList = (page?: number, noLoading?: boolean) => ({
  type: "@saga/GET_WAITING_LIST",
  payload: { page, noLoading },
});
